//
// anz analytics integration
//

var analytics = (function () {
    'use strict';

    var nextButtonSelector = '[data-sf-btn-role="next"]';
    var prevButtonSelector = '[data-sf-btn-role="prev"]';

    var observing = false;

    function sendAnalyticsData() {
        let separators = $("div[data-sf-role='separator']");
        for (let separator of separators.toArray()) {
            if ($(separator).css("display") != "none") {
                var analyticsSpan = $(separator).find('span[analytics-role="name"]');

                var result = "";
                if (analyticsSpan.length) {
                    result = analyticsSpan.attr("analytics-data");
                } else {
                    result = "request-for-financial-assistance";
                }

                window.digitalData.page.pageInfo.pageName = result;
                fireViewStart({});
                fireViewEnd();
                break;
            }
        }
    }

    function init() {
        const callBack = function (mutationsList, observer) {
            sendAnalyticsData();

            observer.disconnect();
            observing = false;
        };

        const observer = new MutationObserver(callBack);

        function prepareSendAnalytics() {
            if (!observing) {
                var element = $(this);
                while (element.attr("data-sf-role") != "separator") {
                    element = element.parent();
                }

                const config = { attributes: true, childList: false, subtree: false };

                observing = true;
                observer.observe(element[0], config);
            }
        }

        $(nextButtonSelector).on('click', prepareSendAnalytics);
        $(prevButtonSelector).on('click', prepareSendAnalytics);
    }

    if ($(nextButtonSelector).length) {
        init();
    }
})();
